/* eslint-disable */
import config from '@/config/config' // 全局配置
import {mapState, mapActions} from 'vuex'
import {MessageBox} from 'element-ui'
let new_mxDomain={}
if(config.domain.id){
	new_mxDomain={
  ename: config.domain.ename||'',
	title: config.domain.alias_name||config.domain.title,
	logo: config.domain.logo_login,
	logo_top: config.domain.logoTop,
	backgroundImg: config.domain.background,
	siderLogo: config.domain.sider_logo,
	location: config.domain.location||'',
	appId: config.domain.app_id,
    alipayAppId: config.domain.alipayAppId,
	appIndividualId:'1002',
	 beianCode:config.domain.beian_no
	}
}
let now_company = JSON.parse(localStorage.getItem('nowCompany'));
if(now_company?.id){
  let company_list = ['481138879232757760', '513047035629875200', '514454972475772928', '522113046366695424']
  if(company_list.includes(now_company?.id)){
    new_mxDomain.appId='10009'
  }
}
const common = {
  data() {
    return {
      // APP 信息
      mxConfig: {
        imageMaxSize: 5242880, // 图片限制5M
        defaultAvatar: 'https://img.51xinlong.com/static/images/avatar-male.png', // 默认头像
        defaultCover: 'https://img.51xinlong.com/static/images/cover.png', // 默认封面
        defaultBanner: 'https://img.51xinlong.com/static/images/banner.png',
      },
      //oss图片信息
      mxDomain: {
        title: this.$config.domain.title,
        logo: this.$config.ossDomain + '/' + this.$config.ossAppDir + this.$config.domain.logo,
        logo_top: this.$config.domain.logoTop ? this.$config.ossDomain + '/' + this.$config.ossAppDir + this.$config.domain.logoTop : '',
        backgroundImg: this.$config.ossDomain + '/' + this.$config.ossAppDir + this.$config.domain.backgroundImg,
        siderLogo: this.$config.ossDomain + '/' + this.$config.ossAppDir + this.$config.domain.siderLogo,
        appQR: this.$config.ossDomain + '/' + this.$config.ossAppDir + this.$config.domain.appQR,
        location: this.$config.domain.location,
        appId: this.$config.domain.appId,
        alipayAppId: config.domain.alipayAppId,
        appIndividualId: this.$config.domain.appIndividualId,
		    beianCode: this.$config.domain.beianCode,
        oemH5:this.$config.domain.oemH5,
		    ...new_mxDomain,//覆盖
      }
    }
  },
  computed: {
    mxShowContract: {
      get() {
        if (this.mxIsContract <= 0 || this.mxIsContract == 2) {
          return true
        }
        return false
      }
    },
    ...mapState({
      mxUserInfo: (state) => state.userInfo,
      mxIsContract: (state) => state.isContract,
    })
  },
  watch: {},
  methods: {
    ...mapActions({
      // mxInitSwitch: 'initSwitch',
      mxInitUserInfo: 'initUserInfo',
      mxInitSwitch: 'initSwitch',
    }),

    //计算金额
    mxServicePrice(inputPrice, taxrate,rateType) {
	  let totalMoney,price,resMoney;
	  if(rateType == 1){
		  totalMoney = inputPrice / (1 + taxrate * 0.01)
		  resMoney = inputPrice * (1 + taxrate * 0.01)
	  }else{
		  totalMoney = inputPrice * (1 - taxrate * 0.01)
		  resMoney = inputPrice * (1 - taxrate * 0.01)
	  }
	  price = inputPrice - totalMoney
      price = Math.round(price * 100) / 100
	  price = price.toFixed(2)
      // 金额格式化2位小数
	  let obj = {price,resMoney}
      return obj
    },
    mxSetVue(vue) {
      this.vue = vue
    },
    // ------------|传值|------------
    // 获取query
    mxGetQuery(name, value = '') {
      return this.$route.query[name] || value
    },
    // 编码参数形成Link字符串
    mxEncodeParamsToLink(obj) {
      const params = [] // 定义参数集
      Object.keys(obj).forEach((key) => {
        let value = obj[key]
        // 如果值为undefined我们将其置空
        if (typeof value === 'undefined') {
          value = ''
        }
        // 对于需要编码的文本（比如说中文）我们要进行编码
        params.push([key, encodeURIComponent(value)].join('='))
      })
      return params.join('&')
    },

    // ------------|页面跳转|------------
    // URL 跳转
    // 路径/传参/是否是tabbar页面/是否必须登录
    mxRedirect(path, query) {
      this.$router.push({path: path, query: query});
    },
    // URL 快速跳转
    mxFastRedirect(data) {
      data = typeof data == 'string' ? JSON.parse(data) : data
      let {path, query = {}, isTab = false} = data
      if (path) {
        this.$router.push({
          path: path,
          query: query,
          isTab: isTab
        })
      } else {
        console.log("url路径不对: ${data}")
      }
    },
    mxRedirectFilterUrl(URL, type = true) {
      this.mxRedirect('/')
    },
    // URL 外部链接快速跳转
    mxGoUrl(url) {
      window.open(url)
    },
    // 预览文件
    mxPreview(url) {
      console.log(url, "url")
      if (url) {
        let arr = url.split(".")
        let suffixName = arr[arr.length - 1].toLowerCase()
        console.log(suffixName, "suffixName")
        if (suffixName == 'xls' || suffixName == 'xlsx' || suffixName == 'doc' || suffixName == 'docx' || suffixName == 'ppt' || suffixName == 'pptx') {
          const href = `https://view.officeapps.live.com/op/view.aspx?src=${url}`
          window.open(href, '_blank')
        } else {
          const href = url
          window.open(href, '_blank')
        }
      } else {
        let errMsg = '暂无文件，请先上传业务清单'
        MessageBox.alert(errMsg, '系统提示', {
          confirmButtonText: '确定',
          type: 'error',
        })
      }
    },

    //查看电子回单
    async mxViewReceipt(id,bank_type='',receipt_url='') {
        let dataUrl = '';
        if(receipt_url){
            dataUrl = receipt_url
            window.open(dataUrl, '_blank')
            return;
        }else{
            dataUrl = `${this.$config.ossDomain}/${this.$config.ossAppDir}/e-receipt/${id}.pdf`
        }
      
      let isExisted = true//控制是否跳转打开电子回单，默认可跳转
      //捕获假接口
      try {
        let res = await this.$api.getReceipt(dataUrl)
        isExisted = true;
        if (!res) {
          isExisted = false
        }
      } catch (error) {
        let errMsg = '暂无电子回单，请下发次日17:00后再试'
        let lignxinList = ['lingxin','lingxincard','lingxinalipay','lingxinwechat']
        if(lignxinList.includes(bank_type)){
          errMsg = '暂无电子回单，请下发两日后再试'
        }
        let shuiyoudiList = ['sycard', 'syalipay', 'sywechat']
        if(shuiyoudiList.includes(bank_type)){
            errMsg = '暂无电子回单，请下发次日19:00后再试'
        }
		let bankList = ['pingan', 'pinganpay','newpinganpay','newwechat']
		if (bankList.includes(bank_type)){
		  errMsg = '暂无电子回单，请次日17:00后再试'
		}
		let bankList_yl = ['ylzhaoshang']
		if (bankList_yl.includes(bank_type)){
		  errMsg = '暂无电子回单，请下发次日17:00后再试'
		}
        // 平安银行15点以后下载  支付宝不支持 其他通道11点以后下载
        if (error.status == 404) {
          isExisted = false;
          MessageBox.alert(errMsg, '系统提示', {
            confirmButtonText: '确定',
            type: 'error',
          })
        }
      }
      if (isExisted) {
        window.open(dataUrl, '_blank')
      } else {
        console.log(isExisted)
      }
    },
    // ------------|图片|------------
    // 获取OSS图片完整地址
    mxGetOssUrl(url, hash = false) {
      let flag = url.indexOf('?') < 0 ? '?' : '&'
      if (url.indexOf('http') < 0 && url.indexOf('https') < 0) {
        // url = `${config.ossDomain}/${url}`
        url = `${config.ossDomain}/${config.ossAppDir}${url}`
      }
      return hash ? `${url}${flag}hash=${new Date().getTime()}` : url
    },
    // 退出通用的方法
    mxLogout() {
      this.$api.submitLogout()
      localStorage.removeItem('user_info')
      this.$message.success('退出成功！')
      this.$router.push('/login')
    },
    // 切换switch的状态
    mxToggleSwitch(name, bool) {
      if (bool) {
        this[name] = bool
      } else {
        this[name] = !this[name]
      }
    },
    // 切换显示:通用方法
    mxToggleShow(name, bool) {
      this.R('toggleShow ' + name + ' 切换')
      if (bool) {
        this[name] = bool
      } else {
        this[name] = !this[name]
      }
      // 要增加或者减少对象属性
      // this.$set(this, name, !this[name])
    },
    // ------------|文字/字符串|------------
    // 首字母大写
    mxCapitalTitle(str, onlyfirst = false) {
      // 只有首字母大写,其余全部小写
      if (onlyfirst) {
        return str.slice(0, 1).toUpperCase() + str.slice(1).toLowerCase()
      }
      return str.slice(0, 1).toUpperCase() + str.slice(1)

    },
    // 重置分页
    mxResetPage(table = 'apeTable', size = 1) {
      this.$refs[table].currentPage = size
    },

    //判断是闰年吗？闰年2月29天
    mxIsRunYear(fullYear) {
      return (fullYear % 4 == 0 && (fullYear % 100 != 0 || fullYear % 400 == 0));
    },
    // 截取文字内容长度
    mxFilters(str, length, ellipsis = 1) {
      let strlen = 0
      let s = ''
      for (let i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) > 128) {
          strlen += 2;
        } else {
          strlen++;
        }
        s += str.charAt(i);
        if (strlen >= length) {
          return ellipsis ? s + "..." : s;
        }
      }
      return str;
    },

    //金额大写转化
    convertCurrency(money) {
      //汉字的数字
      var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖');
      //基本单位
      var cnIntRadice = new Array('', '拾', '佰', '仟');
      //对应整数部分扩展单位
      var cnIntUnits = new Array('', '万', '亿', '兆');
      //对应小数部分单位
      var cnDecUnits = new Array('角', '分', '毫', '厘');
      //整数金额时后面跟的字符
      var cnInteger = '整';
      //整型完以后的单位
      var cnIntLast = '元';
      //最大处理的数字
      var maxNum = 999999999999999.9999;
      //金额整数部分
      var integerNum;
      //金额小数部分
      var decimalNum;
      //输出的中文金额字符串
      var chineseStr = '';
      //分离金额后用的数组，预定义
      var parts;
      if (money == '') {
        return '';
      }
      money = parseFloat(money);
      if (money >= maxNum) {
        //超出最大处理数字
        return '';
      }
      if (money == 0) {
        chineseStr = cnNums[0] + cnIntLast + cnInteger;
        return chineseStr;
      }
      //转换为字符串
      money = money.toString();
      if (money.indexOf('.') == -1) {
        integerNum = money;
        decimalNum = '';
      } else {
        parts = money.split('.');
        integerNum = parts[0];
        decimalNum = parts[1].substr(0, 4);
      }
      //获取整型部分转换
      if (parseInt(integerNum, 10) > 0) {
        var zeroCount = 0;
        var IntLen = integerNum.length;
        for (var i = 0; i < IntLen; i++) {
          var n = integerNum.substr(i, 1);
          var p = IntLen - i - 1;
          var q = p / 4;
          var m = p % 4;
          if (n == '0') {
            zeroCount++;
          } else {
            if (zeroCount > 0) {
              chineseStr += cnNums[0];
            }
            //归零
            zeroCount = 0;
            chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
          }
          if (m == 0 && zeroCount < 4) {
            chineseStr += cnIntUnits[q];
          }
        }
        chineseStr += cnIntLast;
      }
      //小数部分
      if (decimalNum != '') {
        var decLen = decimalNum.length;
        for (var i = 0; i < decLen; i++) {
          var n = decimalNum.substr(i, 1);
          if (n != '0') {
            chineseStr += cnNums[Number(n)] + cnDecUnits[i];
          }
        }
      }
      if (chineseStr == '') {
        chineseStr += cnNums[0] + cnIntLast + cnInteger;
      } else if (decimalNum == '') {
        chineseStr += cnInteger;
      }
      return chineseStr;
    }
  }
}

export default common
